import React, { useState } from "react";
import MegaMenuCategoryList from "./MegaMenuCategoryList";

const classMapping = {
  marketing: "marketingMenu",
  business: "businessMenu",
  insights: "insightsMenu",
  practices: "bestPracticeMenu",
  therapistWellness: "therapistMenu",
};
function BlogMegaMenu({ headClass, setHeadClass, blogData }) {
  const [openMegaMenu, setOpenMegaMenu] = useState(false);
  const [activeClass, setActiveClass] = useState("");
  const [oldClass, setOldClass] = useState("");
  const [isOdd, setisOdd] = useState(true);
  const activeClasses = `${activeClass} active`;
  const className1 = `fixClass ${isOdd ? activeClasses : oldClass}`;
  const className2 = `fixClass ${!isOdd ? activeClasses : oldClass}`;
  return (
    <ul className={`dropdown-menu megamenu fullHeight ${headClass} ${openMegaMenu ? "d-none" : "d-block"} `}>
      <div className={className1} />
      <div className={className2} />

      <div className="row position-relative zIndex-1">
        {blogData
          ?.filter((cat) => cat.sub_type.length > 0)
          .map((item) => {
            return (
              <MegaMenuCategoryList
                activeClass={activeClass}
                setActiveClass={setActiveClass}
                oldClass={oldClass}
                setOldClass={setOldClass}
                isOdd={isOdd}
                setisOdd={setisOdd}
                key={item.id}
                setHeadClass={setHeadClass}
                blogData={item}
                categoryType={item.class_name}
                categoryTypeClassName={classMapping[item.class_name]}
                setOpenMegaMenu={setOpenMegaMenu}
              />
            );
          })}
      </div>
    </ul>
  );
}
export default BlogMegaMenu;
